





























































































































import http from "@/axios/http-common";
import { Component, Vue, Watch, Ref, Prop } from "vue-property-decorator";
import { resepStore } from "@/store/modules/resep";
import {
  petunjukAlternatifObat,
  ringkasStokObat,
  susunHasilPencarianObat
} from "@/utils/pencarianObat";

@Component
export default class ObatSearchBox extends Vue {
  @Prop() showed: boolean;
  @Prop() depoId?: string;
  @Prop({ default: "Cari Obat" }) label?: string;
  @Prop({ default: "Ketik nama obat untuk mencari" }) placeholder?: string;
  @Prop({ default: false }) outlined?: boolean;

  public entries = [];
  public isLoading = false;
  public model = null;
  public search = null;
  public _timerId;
  public itemHighlightedIdx = null;
  public nomorPermintaan = 0;

  @Ref() readonly searchBox!: HTMLInputElement;

  get depoIdComputed() {
    return this.depoId || resepStore.depoId;
  }

  get obatList() {
    return susunHasilPencarianObat(this.entries);
  }

  focus() {
    this.searchBox.focus();
  }

  cari(teks: string) {
    setTimeout(() => {
      this.focus();
      this.$nextTick(() => {
        this.search = teks;
      });
    }, 0);
  }

  selectObat(val) {
    if (!val.stock_qty) {
      const q = confirm(
        `Obat/Alkes yang Anda pilih (${val.nama}) tidak ada stok tersedia. Tetap lanjut?`
      );

      const kw = this.search;

      if (!q) {
        this.entries = [];
        this.searchBox.focus();

        setTimeout(() => {
          this.search = kw;
        }, 100);

        return;
      }
    }

    this.search = null;
    this.entries = [];

    this.$emit("select-obat", val);

    this.$nextTick(() => {
      this.searchBox.blur();
    });
  }

  renderStock(data) {
    return ringkasStokObat(data);
  }

  petunjukAlternatif(data) {
    return petunjukAlternatifObat(data);
  }

  renderRestriksi(data) {
    return data.restriksi
      ? `Restriksi ${data.nama} : <br/>` + data.restriksi
      : "";
  }

  @Watch("search")
  changedSearch() {
    this.entries = [];
    this.nomorPermintaan++;

    clearTimeout(this._timerId);

    this._timerId = setTimeout(() => {
      if (this.search === null || this.search.length < 3) return;

      const nomor = ++this.nomorPermintaan;
      this.isLoading = true;

      http
        .getDataParam("/referensi/obat/search", {
          params: { term: this.search, depo: this.depoIdComputed }
        })
        .then(res => {
          if (nomor === this.nomorPermintaan) {
            this.entries = res.data;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          if (nomor === this.nomorPermintaan) {
            this.isLoading = false;
          }
        });
    }, 500);
  }

  showWarningModal(item) {
    alert("Restriksi: \r\n" + item.restriksi);
  }

  listItemIndexUpdated(val) {
    this.itemHighlightedIdx = val;
  }

  @Watch("showed")
  changedShowed(show: boolean) {
    if (show) {
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.focus();
        });
      });
    }
  }
}
